import { FieldValues, Path } from "react-hook-form";

import { FormInput } from "../../../components/Input";
import {
  NOTE_HELPER,
  NOTE_LABEL,
  NOTE_PLACEHOLDER,
  noteRule,
} from "./constants";
import {
  Field,
  FieldHelper,
  FieldLabel,
  LabelRow,
} from "../../../components/FormPanel";
import { NoteFieldProps } from "./types";

// Shared by eight call sites (buy, sell, account cash, correction × desktop/compact) so the label, cap and wording can't drift between a panel and its compact twin.
export const NoteField = <T extends FieldValues>({
  id,
  control,
  isSubmitting,
}: NoteFieldProps<T>) => (
  <Field>
    <LabelRow>
      <FieldLabel htmlFor={id}>{NOTE_LABEL}</FieldLabel>
    </LabelRow>
    <FormInput
      id={id}
      name={"note" as Path<T>}
      control={control}
      rules={noteRule}
      disabled={isSubmitting}
      placeholder={NOTE_PLACEHOLDER}
    />
    <FieldHelper>{NOTE_HELPER}</FieldHelper>
  </Field>
);
